import { createConsumer } from "@rails/actioncable"

// usa URL absoluta do browser → evita problemas de VM/proxy
const consumer = createConsumer(`ws://${window.location.host}/cable`)

export default consumer